import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Subscribe.css";

export default function Subscribe() {

    const navigate = useNavigate();

    const [showPayment, setShowPayment] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("");

    const amount = 1000;
    const bonus = 200;
    const totalBalance = amount + bonus;


    // =========================
    // SUBSCRIBE BUTTON
    // =========================

    const handleSubscribe = () => {

        setShowPayment(true);

    };


    // =========================
    // PAYMENT
    // =========================

    const handlePayment = () => {

        if (!paymentMethod) {

            alert("⚠️ Please select a payment method!");

            return;
        }


        // Demo payment success

        const wallet = {

            paidAmount: amount,

            bonusAmount: bonus,

            balance: totalBalance,

            subscribed: true,

            paymentMethod: paymentMethod,

            subscriptionDate:
                new Date().toISOString()

        };


        localStorage.setItem(
            "coffeeWallet",
            JSON.stringify(wallet)
        );


        alert(
            `🎉 Payment Successful!\n\n` +
            `Paid Amount: ₹${amount}\n` +
            `Bonus: ₹${bonus}\n` +
            `Wallet Balance: ₹${totalBalance}\n\n` +
            `Payment: ${paymentMethod}`
        );


        navigate("/");

    };


    return (

        <div className="subscription-page">


            {/* =========================
                HEADER
            ========================= */}

            <div className="subscription-header">

                <span>
                    SRINEEVI COFFEE HOUSE
                </span>

                <h1>
                    Subscribe & <strong>Save More</strong>
                </h1>

                <p>
                    Enjoy your favourite tea, coffee
                    and snacks using your membership wallet.
                </p>

            </div>


            {/* =========================
                PAYMENT SCREEN
            ========================= */}

            {showPayment ? (

                <div className="subscription-container">

                    <div className="subscription-card payment-card">

                        <div className="plan-icon">
                            💳
                        </div>

                        <h2>
                            Choose Payment Method
                        </h2>

                        <p>
                            Complete your ₹1000 subscription payment.
                        </p>


                        {/* PAYMENT SUMMARY */}

                        <div className="payment-summary">

                            <div>
                                <span>
                                    Subscription
                                </span>

                                <strong>
                                    ₹1000
                                </strong>
                            </div>

                            <div>
                                <span>
                                    Bonus
                                </span>

                                <strong>
                                    + ₹200
                                </strong>
                            </div>

                            <hr />

                            <div>
                                <span>
                                    Wallet Balance
                                </span>

                                <strong>
                                    ₹1200
                                </strong>
                            </div>

                        </div>


                        {/* UPI */}

                        <label className="payment-option">

                            <input
                                type="radio"
                                name="payment"
                                value="UPI"
                                checked={
                                    paymentMethod === "UPI"
                                }
                                onChange={(e) =>
                                    setPaymentMethod(
                                        e.target.value
                                    )
                                }
                            />

                            <span>
                                📱 UPI
                            </span>

                        </label>


                        {/* CARD */}

                        <label className="payment-option">

                            <input
                                type="radio"
                                name="payment"
                                value="Debit / Credit Card"
                                checked={
                                    paymentMethod ===
                                    "Debit / Credit Card"
                                }
                                onChange={(e) =>
                                    setPaymentMethod(
                                        e.target.value
                                    )
                                }
                            />

                            <span>
                                💳 Debit / Credit Card
                            </span>

                        </label>


                        {/* NET BANKING */}

                        <label className="payment-option">

                            <input
                                type="radio"
                                name="payment"
                                value="Net Banking"
                                checked={
                                    paymentMethod ===
                                    "Net Banking"
                                }
                                onChange={(e) =>
                                    setPaymentMethod(
                                        e.target.value
                                    )
                                }
                            />

                            <span>
                                🏦 Net Banking
                            </span>

                        </label>


                        {/* PAYMENT BUTTON */}

                        <button
                            className="subscribe-button"
                            onClick={handlePayment}
                        >
                            Pay ₹1000 & Subscribe
                        </button>


                        {/* BACK */}

                        <button
                            className="back-payment-btn"
                            onClick={() =>
                                setShowPayment(false)
                            }
                        >
                            ← Back
                        </button>

                    </div>

                </div>

            ) : (

                /* =========================
                   SUBSCRIPTION DETAILS
                ========================= */

                <div className="subscription-container">

                    <div className="subscription-card popular">

                        <div className="popular-badge">
                            ⭐ SPECIAL OFFER
                        </div>


                        <div className="plan-icon">
                            ☕
                        </div>


                        <h2>
                            Srineevi Membership
                        </h2>


                        <p>
                            Pay ₹1000 and get ₹200 extra bonus!
                        </p>


                        <div className="plan-price">

                            <span>
                                ₹1000
                            </span>

                            <small>
                                Subscription
                            </small>

                        </div>


                        <div className="bonus-box">

                            <p>
                                🎁 Your Bonus
                            </p>

                            <h2>
                                + ₹200
                            </h2>

                        </div>


                        <div className="total-balance">

                            <span>
                                Total Wallet Balance
                            </span>

                            <strong>
                                ₹1200
                            </strong>

                        </div>


                        <ul>

                            <li>
                                <span>✓</span>
                                ₹1000 Subscription Amount
                            </li>

                            <li>
                                <span>✓</span>
                                ₹200 Free Bonus
                            </li>

                            <li>
                                <span>✓</span>
                                Buy Tea & Coffee
                            </li>

                            <li>
                                <span>✓</span>
                                Buy Snacks & Food
                            </li>

                            <li>
                                <span>✓</span>
                                Amount deducted automatically
                            </li>

                        </ul>


                        <button
                            className="subscribe-button"
                            onClick={handleSubscribe}
                        >
                            Subscribe for ₹1000
                        </button>

                    </div>

                </div>

            )}


            <div className="subscription-bottom">

                <h3>
                    ☕ Your Wallet. Your Choice.
                </h3>

                <p>
                    Use your balance anytime for your
                    favourite Tea, Coffee and Snacks.
                </p>

            </div>

        </div>

    );
}